module.exports = __webpack_public_path__ + "static/ticket-back-052b14fe1eec350551af3a3cb8df9e8a.png";